import * as React from "react";
import FormInput from "./FormInput";
import RichTextEditor, { RichTextEditorQuickLinks } from "../../RichTextEditor";
import InputProps from "../../../model/form/InputProps";
import InputState from "../../../model/form/InputState";
import { buildClasses } from "../../../utils/classes";
import { useState } from "react";

interface RichTextEditorInputProps extends InputProps {
  className?: string;
  cssUrl: string;
  height?: string;
  maxSize?: number;
  toolbar?: string;
  quickLinks?: RichTextEditorQuickLinks;
}

const RichTextEditorInput = (props: RichTextEditorInputProps) => {
  const [textContent, setTextContent] = useState("");
  const template = (state: InputState, input) => {
    return (
      <div
        className={buildClasses(
          { invalid: () => state.status.invalid && !state.status.pristine },
          "input-group"
        )}
      >
        <label htmlFor={props.name}>
          <span>{props.label}</span>
          <span className="detail">{props.detail}</span>
        </label>
        <div className="group">
          <RichTextEditor
            name={props.name}
            disabled={state.status.disabled}
            cssUrl={props.cssUrl}
            className={props.className}
            value={state.value}
            onChange={(value) => {
              input.setValue(value);
              input.dirty();
            }}
            onTextChange={(value) => {
              setTextContent(value);
              if (value.length > props.maxSize) {
                input.setInvalid(true, i18n["Form.Error.MaxLength"]);
              }
            }}
            height={props.height}
            toolbar={props.toolbar}
            quickLinks={props.quickLinks}
          />
        </div>
        <div className="input-accessories">
          <div className="error-message">{state.status.errorMessage}</div>
          {props.maxSize && (
            <div className="size-limit">
              {textContent.length} / {props.maxSize}
            </div>
          )}
        </div>
      </div>
    );
  };

  return <FormInput {...props} template={template} />;
};

export default RichTextEditorInput;
